import React from 'react';
export function SolutionSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-378">
      <div className="max-w-4xl mx-auto text-center" data-id="element-379">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-[#F97316]/50 text-[#F97316] font-bold text-sm px-5 py-2 rounded-full mb-8 tracking-wide" data-id="element-380">
          🏆 El Sistema Más Completo para Entrenadores de Básquet en Habla
          Hispana
        </div>

        <h2 className="text-4xl sm:text-5xl font-black text-white mb-4" data-id="element-381">
          🏀 EDULABS™
        </h2>
        <h3 className="text-2xl sm:text-3xl font-bold text-[#F97316] mb-6" data-id="element-382">
          MEGAPACK BÁSQUET LISTO
        </h3>
        <p className="text-white text-lg max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-383">
          <strong data-id="element-384">
            6 Tomos + 6 Bonos — Todas las categorías — Todo resuelto.
          </strong>
          <br data-id="element-385" />
          +300 páginas · 150 sesiones modelo · 101 drills pro · Técnica ·
          Táctica · Físico · Tiro · Planificación · Evaluación · Gestión ·
          Comunicación. Funciona desde hoy. En cualquier país. En cualquier
          club.
        </p>

        {/* Mockup visual */}
        <div className="relative mx-auto mb-10 max-w-2xl" data-id="element-386">
          <div className="grid grid-cols-6 gap-2 justify-center" data-id="element-387">
            {['#1565C0', '#2E7D32', '#E65100', '#6A1B9A', '#37474F', '#BF360C'].map((color, i) => {
            const labels = ['U10/U12', 'U13/U15', 'U17/U19', 'Físico', 'Drills', 'Gestión'];
            return <div key={i} className="aspect-[3/4] rounded-lg shadow-2xl flex items-end justify-center pb-2" style={{
              backgroundColor: color,
              border: '2px solid #F97316'
            }} data-id="element-388">
                  <span className="text-white text-xs font-bold" style={{
                textShadow: '0 1px 3px rgba(0,0,0,0.8)'
              }} data-id="element-389">
                    {labels[i]}
                  </span>
                </div>;
          })}
          </div>
          <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-[#F97316] text-black font-black text-xs px-4 py-1 rounded-full whitespace-nowrap" data-id="element-390">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mt-8" data-id="element-391">
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-392">
            ✅ Por categoría de edad y nivel formativo
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-393">
            ✅ 150 sesiones completas con objetivo y cierre
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-394">
            ✅ Evaluación + planillas de progreso por categoría
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-395">
            ✅ Técnica + Táctica + Físico + Tiro + Gestión + Comunicación
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-396">
            ✅ Español neutro — funciona en cualquier país de habla hispana
          </span>
          <span className="bg-[#F97316]/10 border border-[#F97316]/40 text-[#F97316] text-sm font-semibold px-4 py-2 rounded-full" data-id="element-397">
            ✅ Adaptable a cualquier club, escuela o academia
          </span>
        </div>
      </div>
    </section>;
}